import engine from 'store/src/store-engine'
import sessionStorage from 'store/storages/sessionStorage'
import pluginDefault from 'store/plugins/defaults'
import pluginExpire from 'store/plugins/expire'

const storages = [
  sessionStorage
]

const plugins = [
  pluginDefault,
  pluginExpire
]

export default engine.createStore(storages, plugins)
